export function formatResultDate(value) {
  if (!value) return '';

  let text = String(value).trim();
  if (!text) return '';

  text = text.replace(/(\.\d{3})\d+/, '$1');
  const hasTimezone = /[zZ]$|[+-]\d{2}:\d{2}$/.test(text);
  if (!hasTimezone && /^\d{4}-\d{2}-\d{2}T/.test(text)) {
    text += 'Z';
  }

  const date = new Date(text);
  if (Number.isNaN(date.getTime())) return '';

  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  return `${yyyy}.${mm}.${dd}`;
}

